










































































import { defineComponent, reactive, toRefs, onMounted, ref, watch } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue"
import { BTable } from 'bootstrap-vue';
import { SearchCondition, CramStudent } from "../../modules/teacher/SumupResultDownload"

export interface Data {
  condition: SearchCondition
  cramStudents: CramStudent[]
  isAllCheckDownload: boolean
  fields: any[]
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      condition: new SearchCondition(),
      cramStudents: [],
      isAllCheckDownload: false,
      fields: [
        {key: "sheet_code", label: "試験CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "room_code", label: "教室CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "class_code", label: "クラスCD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "curriculum_id", label: "科目CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "times", label: "テストNO", sortable: true, class: 'text-center b-table-th-td'},
        {key: "created_at", label: "実施日", sortable: true, class: 'text-center b-table-th-td'},
        {key: "cram_code", label: "塾生CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "student_name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "score", label: "得点", sortable: true, class: 'text-center b-table-th-td'},
        {key: "result_downloaded_at", label: "ダウンロード日時", sortable: true, class: 'text-center b-table-th-td'},
        {key: "isSelected", label: "選択", sortable: false, class: 'text-center b-table-th-td'},
      ],
      errors: [],
    });

    /******************************
     * ヘッダ選択チェックボックス
     ******************************/

    watch(() => state.isAllCheckDownload, (newVal, oldVal) => {
      console.log(`newVal: ${newVal}, oldVal: ${oldVal}`);
      state.cramStudents.forEach(x => x.isSelected = newVal);
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = async () => {
      await search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {

      state.errors = []

      if(!state.condition.created_at_from || !state.condition.created_at_to){
        state.errors.push("実施日を入力してください。");
        return;
      }

      if(!window.confirm("成績情報をダウンロードします。よろしいですか？")){
        return;
      }
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/sumup_result_download?${Common.BuildQuery(state.condition, 'search_condition')}`).then(async response => {
        state.cramStudents = response.data.cram_students.map((x: any) => new CramStudent(x));
        if(state.cramStudents.length == 0){
          alert("条件に一致するデータはありませんでした。");
        }else{
          await download();
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * ダウンロード
     ******************************/

    const download = async () => {

      state.errors = []

      const cramStudents = state.cramStudents;

      // if(cramStudents.length == 0){
      //   state.errors.push("ダウロード対象を選択してください。");
      //   return;
      // }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/sumup_result_download/result_downloaded_at`, {examinee_ids: cramStudents.map(x => x.examinee_id)}).then(response => {
        let csvData = '';

        const header = ["教室CD", "クラスCD", "科目CD", "テストNO", "実施日", "講座CD", "生徒CD", "塾生CD", "年度", "得点", "データ作成日"];
        csvData += header.join(',') + '\r\n';

        const nowDate = moment().format("Y/M/D");

        cramStudents.forEach(x => {
          const cols = [];
          cols.push(x.room_code);
          cols.push(x.class_code);
          cols.push(x.curriculum_id);
          cols.push(x.times);
          cols.push(x.created_at);
          cols.push(x.course_code);
          cols.push(x.student_code);
          cols.push(x.cram_code);
          cols.push(x.nendo);
          cols.push(x.score);
          cols.push(nowDate);
          csvData += cols.join(',') + '\r\n';
        });

        const link = document.createElement('a');
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
        let blob: any = null;
        const csvName = `生徒成績_${moment().format("YMD")}`;

        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([bom, csvData], {type: 'text/csv'});
          window.navigator.msSaveOrOpenBlob(blob, csvName);
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([bom, csvData], {type: 'text/csv'});
          link.setAttribute('download', csvName);
          link.setAttribute('href', window.webkitURL.createObjectURL(blob));
          link.click();
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([bom, csvData], {type: 'text/csv'});
          link.setAttribute('download', csvName);
          link.setAttribute('href', window.URL.createObjectURL(blob));
          link.click();
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      // await search();
    });

    return {
      ...toRefs(state),
      tableRef,
      searchClick,
      search,
      clearCondition,
      download,
    };
  }
});
